import React from 'react';
import { Loading } from '@shopify/polaris';

const PageLoading: React.FC = () => {
  return <Loading />;
};

export default PageLoading;
